import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

const TermsPage = () => {
  return <SanityContentPage slug='terms' />
}

export default TermsPage
